import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getCustomerInfo, customerLogin, customerRegister, type CustomerLoginParams } from '@/api/customer/auth';
import { getAgencyStatus } from '@/api/agency';
import { getMyWallet, type MyWalletResponse } from '@/api/wallet';
import { useCartStore } from '@/store/cart';

export const useUserStore = defineStore('user', () => {
  const token = ref(uni.getStorageSync('customer_token') || '');
  const userInfo = ref<any>(null);
  const agencyStatus = ref<any>(null);
  const wallet = ref<MyWalletResponse | null>(null);

  // 登录
  const login = async (params: CustomerLoginParams) => {
    const res: any = await customerLogin(params);
    // 假设 res 返回的是 { access_token: string, token_type: string }
    token.value = res.access_token;
    uni.setStorageSync('customer_token', res.access_token);
    await getUserInfo();
    
    // 登录后刷新购物车角标
    try {
      useCartStore().fetchList();
    } catch (e) {}
    
    return res;
  };

  // 获取用户信息
  const getUserInfo = async () => {
    try {
      const res = await getCustomerInfo();
      userInfo.value = res;
      // 获取用户信息同时获取服务商状态
      fetchAgencyStatus();
      // 获取钱包信息
      fetchWallet();
      return res;
    } catch (error) {
      console.error('Get user info failed', error);
    }
  };

  // 获取服务商状态
  const fetchAgencyStatus = async () => {
    try {
      const res = await getAgencyStatus();
      agencyStatus.value = res;
      return res;
    } catch (error) {
      console.error('Get agency status failed', error);
    }
  };

  // 获取钱包信息
  const fetchWallet = async () => {
    try {
        const res: any = await getMyWallet();
        wallet.value = res.data || res;
        return res;
    } catch (error) {
        console.error('Get wallet info failed', error);
    }
  };

  // 退出登录
  const logout = () => {
    token.value = '';
    userInfo.value = null;
    agencyStatus.value = null;
    wallet.value = null;
    uni.removeStorageSync('customer_token');
    
    // 清除购物车角标
    try {
      const cartStore = useCartStore();
      cartStore.totalCount = 0;
      cartStore.cartList = [];
      cartStore.updateTabBarBadge();
    } catch (e) {}

    uni.reLaunch({ url: '/pages/auth/login' });
  };

  return {
    token,
    userInfo,
    agencyStatus,
    wallet,
    login,
    getUserInfo,
    fetchAgencyStatus,
    fetchWallet,
    logout
  };
});
